import * as apiProxy from 'BASE/common/util/util.apiProxy';
import { actionTypes } from 'BASE/store/types';
import signalr from 'BASE/common/signalrAdapter';
import { storage } from 'BASE/common/util/util.storage';
import { redirect } from 'BASE/common/cordova/cordova.redirect';

export default {
    data: function () {
        return {
            IsMobile: false,
            IsSort: true,       //線路是否依照速度排序
            Several: 0,
            Faking: false,
            WebSiteUrlList: [], //如各站有限只取前幾條最快線路顯示，請在頁面使用slice(0,6)取，如 WebSiteUrlList.slice(0,6)
            DomainName: "",
            DefaultStr: "载入",
            FailedStr: "失败",
            //請由快到慢排序
            LevelList: [
                { speed: 50, class: "fast", text: "极速" },   //speed為ms
                { speed: 100, class: "soso", text: "顺畅" },
                { speed: 500, class: "slow", text: "拥挤" }
            ],

            //如需替換需將檔案放到ClientApp\public\speedtest目錄底下webpack已寫好自動複製規則
            ImagesPath: "/images/speedTest",
            Proxy: ENVIRONMENT.CORDOVA ? apiProxy.get() : '',
            goLinkPage: "/?page=speedtest",
            IsAutoSpeedTest: false,
        };
    },
    computed: {
        MaxSpeed() {
            //前台頁面超過該設定值可自行判別是否改顯示 "链结超时"
            let levelItem = this.LevelList.length - 1; //最後一各項目speed為最大值
            return this.LevelList[levelItem].speed;
        },
        URLList() {
            return this.$store.state.userinfo.speedTestConfig.URLList;
        },
        SpeedTestIntervalInMinute() {
            return this.$store.state.userinfo.speedTestConfig.IntervalInMinute;
        },
        EnableSwitchURL() {
            return this.$store.state.userinfo.speedTestConfig.EnableSwitchURL;
        },
        isLogin() {
            return this.$store.state.userinfo.isLogin;
        },
        isSpeedTestPath() {
            //如是speedTest頁面並沒有配置$store 及 $router
            return !(this.$store && this.$router);
        },
        IsCordova() {
            return ENVIRONMENT.CORDOVA;
        },
        GetspeedTestURL() {
            let url = "/api/SpeedTest/Init/";
            //Cordova非測速頁的Post已轉換過一次
            if (this.IsCordova && this.isSpeedTestPath) return apiProxy.get() + url;
            return url;
        },
    },
    methods: {
        async init() {
            let _this = this;
            _this.WebSiteUrlList = [];
            try {
                let _speedTestConfig = storage.session.get(storage.keys.SPEED_TEST_CONFIG);
                let _urlList = storage.session.get(storage.keys.SPEED_TEST_URL_LIST);
                let _fatestH5Url = storage.local.get(storage.keys.FATEST_H5_URL);
                if (!_urlList || !_speedTestConfig || _this.isSpeedTestPath || !_fatestH5Url) {
                    try {
                        let _result = await $.post({ url: this.GetspeedTestURL, timeout: this.IsCordova ? 5000 : undefined });
                        _speedTestConfig = _result.wenSiteURLSetting;
                        _urlList = _result.WebSiteUrlList;
                    } catch (error) {
                        if (this.IsCordova) {
                            window.DD_LOGS &&  window.DD_LOGS.logger.log('api SpeedTest Init false. ', { error: error }, 'error');
                            if (window.localStorage.WEB_SITE_URL_LIST) {
                                _urlList = JSON.parse(window.localStorage.WEB_SITE_URL_LIST);
                            }
                        }
                    }
                }
                if (!_this.isSpeedTestPath && _speedTestConfig && _urlList) {
                    this.$store.dispatch(actionTypes.SPEED_TEST_CONFIG, _speedTestConfig);
                    this.$store.dispatch(actionTypes.SPEED_TEST_URL_LIST, _urlList);
                }

                if (_urlList) {
                    $.each(_urlList, function (index, value) {
                        //取得ionic測出最快線路的測速結果
                        if(_this.IsCordova && value.WebSiteUrl == window.localStorage.API_PROXY) {
                            let _levelItem = _this.linkLevel(window.localStorage.API_PROXY_TIME);
                            value.speed_class = _this.LevelList[_levelItem].class;
                            value.speed_str = _this.LevelList[_levelItem].text;
                            value.speed_ms = window.localStorage.API_PROXY_TIME;
                            value.loadSuccess = true; 
                        } else {
                            value.loadSuccess = false;
                            value.speed_ms = "";
                            value.speed_str = _this.DefaultStr;
                            value.speed_class = "";
                        }

                        _this.WebSiteUrlList.push(value);
                    });
                }
                _this.testUrl(true);
            }
            catch (err) {
                console.error(err);
            }

            // Cordova下，註冊CodePush不須更新事件
            redirect.registerNoNeedUpdateEvent();
        },
        retest() {
            let _this = this;
            if (!_this.isSpeedTestPath) this.WebSiteUrlList = this.URLList;         

            $.each(this.WebSiteUrlList, function (index, value) {
                value.loadSuccess = false;
                value.testDone = false;
                value.speed_ms = "";
                value.speed_str = _this.DefaultStr;
                value.speed_class = "";
            });
            this.testUrl();
        },
        testUrl(isFake) {
            let _this = this;
            _this.Faking = isFake;
            _this.Several = 0;
            $.each(this.WebSiteUrlList, function (index, value) {
                //ionic測出最快的線路已有測速結果所以略過該線路
                if(_this.IsCordova && value.loadSuccess) {
                    _this.linkSort();
                } else {
                    _this.loadResources(value, isFake);
                }
            });

            //只有初始測試fake才需配置2秒後額外判別是否重測
            if (isFake) {
                setTimeout(function () {
                    //2秒後如果所有fake.jpg都尚未回應回就立即重做
                    if (_this.Faking) {
                        _this.testUrl();
                    }
                }, 2000);
            }
        },
        loadResources(value, isFake) {
            let _this = this;
            let download = new Image();
            value.startTime = new Date().getTime(); //每條線路開始載入的初始時間
            download.alt = value.DisplayUrl ? value.DisplayUrl : value.WebSiteUrl;//如果沒設定顯示網址,就顯示連結網址
            download.src = value.WebSiteUrl + _this.ImagesPath + (isFake ? "fake" : "") + ".jpg" + "?" + Math.random();
            download.title = value.ID;     //記錄網址的ID

            let timer = setTimeout(() => { download.src = ''; }, 5000);

            download.onerror = function () {
                clearTimeout(timer);
                _this.onloadError(this.title);
            };
            if (!isFake) {
                download.onload = function () {
                    clearTimeout(timer);
                    _this.onloadSuccess(this.title);
                };
            }
        },
        onloadSuccess(urlId) {
            let _this = this;
            let _endTime = new Date().getTime();

            $.each(_this.WebSiteUrlList, function (index, value) {
                if (value.ID == urlId) {
                    let _total = Math.round(_endTime) - Math.round(value.startTime);
                    let _timeTotal = Math.floor(_total / 5);
                    _timeTotal = _timeTotal < 1 ? 1 : _timeTotal;

                    let _levelItem = _this.linkLevel(_timeTotal);
                    value.loadSuccess = true;
                    value.testDone = true;
                    value.speed_ms = _timeTotal;
                    value.speed_class = _this.LevelList[_levelItem].class;
                    value.speed_str = _this.LevelList[_levelItem].text;

                    // Cordova下，測速完成後，紀錄最快的domain線路
                    redirect.speedTestFinished(value.WebSiteUrl);

                    return false;
                }
            });
            _this.linkSort();
        },
        onloadError(urlId) {
            let _this = this;
            if (_this.Faking) {
                this.Several++;
                if (this.Several >= this.WebSiteUrlList.length) {
                    this.testUrl();
                }
            }
            else {
                $.each(this.WebSiteUrlList, function (index, value) {
                    if (value.ID == urlId) {
                        value.loadSuccess = false;
                        value.testDone = true;
                        value.speed_str = _this.FailedStr;
                        value.speed_ms = -1;
                        return false;
                    }
                });
                this.linkSort();
            }
        },
        // getRandomId(length) {
        //     var result = '';
        //     var characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
        //     var charactersLength = characters.length;
        //     for ( var i = 0; i < length; i++ ) {
        //         result += characters.charAt(Math.floor(Math.random() * charactersLength));
        //     }
        //     return result;
        // },
        linkLevel(_timeTotal) {
            let _this = this;
            let _levelItem = _this.LevelList.length - 1; //預設最後一各項目
            $.each(_this.LevelList, function (index, value) {
                if (_timeTotal <= value.speed) {
                    _levelItem = index;
                    return false;
                }
            });
            return _levelItem;
        },
        linkSort() {
            if (this.IsSort) {
                this.WebSiteUrlList = this.WebSiteUrlList.sort(function (a, b) {
                    if (a.loadSuccess && b.loadSuccess)
                        return a.speed_ms - b.speed_ms;
                    else if (a.loadSuccess)
                        return -1;
                    else if (b.loadSuccess)
                        return 1;

                    return 0;
                });
            }
            $.each(this.WebSiteUrlList, function (index, value) {
                if (value.IsH5) {
                    storage.local.set(storage.keys.FATEST_H5_URL, value.WebSiteUrl);
                    return false;
                }
            });
        },
        goLink(domain) {
            apiProxy.set(domain);
            //如有跳轉到不同的頁面，請替換goLinkPage
            if (ENVIRONMENT.CORDOVA) {
                window.location.href = apiProxy.urlRedirect(this.goLinkPage);
            }
            else {
                window.location.href = domain + this.goLinkPage;
            }
        },
        goToLink(url) {
            window.location.href = apiProxy.urlRedirect(url);
        },
        async checkDomain() {
            let _this = this;

            if (!_this.DomainName) {
                _this.checkDomainResult("域名无输入，请确认后再检测!");
                return false;
            }

            try {
                let _encodeDomainName = encodeURIComponent(this.DomainName);
                let _result = await $.post(`${_this.Proxy}/api/SpeedTest/CheckDomainName/${_encodeDomainName}`);
                if (_result) {
                    _this.checkDomainResult("此域名为正确域名可安心访问!", _result);
                }
                else {
                    _this.checkDomainResult("注意：此域名为假域名请勿访问!", _result);
                }
            }
            catch (err) {
                console.error(err);
                _this.checkDomainResult("检测失败请重新尝试");
            }
        },
        checkDomainResult(text, result) {
            this.$dialog.warning(text);
        },
        //只有單獨的測速頁使用speedtest.js流程的，如已經混入到其他components請確認不能呼叫該function
        //請放到beforeMount引用
        speedTestAjaxSetup() {
            $.ajaxSetup({
                error: function (jqXHR, textStatus, errorThrown) {
                    switch (jqXHR.status) {
                        //case 0:
                        //    _this.$router.refreshTo(`/ErrorMsg?Msg=jqXHR.status 错误代码:0`);
                        //    break;
                        case 403:
                            //只處理額外添加的事件
                            if (jqXHR.responseText.indexOf('IP_restricted') != -1) {
                                window.location.href = apiProxy.urlRedirect(`/IPRestricted`);
                            }
                            else if (jqXHR.responseText) {
                                window.location.href = apiProxy.urlRedirect(`/Offline`);
                            }

                            break;
                        case 503:
                            window.location.href = apiProxy.urlRedirect(`/Offline?EndTime=${jqXHR.responseJSON.OfflineEndTime}`);
                            break;
                    }
                }
            });
        },
        //測試URL速度並更換URL
        autoSpeedTesting() {
            let _this = this;
            if (_this.SpeedTestIntervalInMinute > 0 && _this.isLogin) {
                setTimeout(function () {
                    if (_this.WebSiteUrlList) {
                        _this.retest();
                        setTimeout(function () {
                            while (_this.WebSiteUrlList[0].speed_ms < 501) {
                                let currentAPIUrl = apiProxy.get();
                                if (currentAPIUrl == _this.WebSiteUrlList[0].WebSiteUrl) return;
                                let HttpsString = "https:"
                                if (window.location.protocol == HttpsString && !_this.IsCordova) {
                                    for (let i = 0; i < _this.WebSiteUrlList.length; i++) {
                                        if (_this.WebSiteUrlList[i].WebSiteUrl.indexOf(HttpsString) == 0 && _this.EnableSwitchURL) {
                                            apiProxy.set(_this.WebSiteUrlList[i].WebSiteUrl);
                                            return;
                                        }
                                    }
                                }
                                else if(_this.EnableSwitchURL) {
                                    apiProxy.set(_this.WebSiteUrlList[0].WebSiteUrl);
                                }
                                return;
                            }
                        }, 1000);
                    }
                    _this.autoSpeedTesting();
                }, _this.SpeedTestIntervalInMinute * 60 * 1000);  //x分鐘更新URL
            }
        },
        checkAutoSpeedTest() {
            if (!this.isSpeedTestPath) {
                if (this.IsAutoSpeedTest) {
                    this.autoSpeedTesting();
                    let _this = this;
                    //如有收到變更權限就通知store變更
                    signalr.addWorkOnConnected(() => {
                        signalr.WebSiteURLConfig.WebSiteURLConfig.addHandler(input => {
                            if (input) {
                                if (_this.SpeedTestIntervalInMinute == 0) {
                                    this.$store.dispatch(actionTypes.SPEED_TEST_CONFIG, input);
                                    this.autoSpeedTesting();   //需先變更store的值才能呼叫
                                }
                                else {
                                    this.$store.dispatch(actionTypes.SPEED_TEST_CONFIG, input);
                                }
                            }
                        });
                    });
                }

                //如有收到變更權限就通知store變更
                signalr.addWorkOnConnected(() => {
                    signalr.URLList.URLList.addHandler(input => {
                        if (input) {
                            this.$store.dispatch(actionTypes.SPEED_TEST_URL_LIST, input);
                        }
                    });
                });
            }
        },
        AfterMountedForCordova() {
            // Cordova版本號確認之後，會先載入Vue測速頁，載好後Cordova再進行後續動作(檢查熱更新or直接顯示測速列表)
            // 後續動作會需要調整測速頁畫面，所以要等Vue測速頁載完再做
            if (this.IsCordova && typeof document.VUE_SPEEDTEST_MOUNTED === "function") {
                document.VUE_SPEEDTEST_MOUNTED();
            }
        },
    },
    beforeMount() {
        //只有在測速頁需要添加ajax定義，其他頁由main.js引用的ajaxSetting配置
        if (this.isSpeedTestPath) {
            this.speedTestAjaxSetup();
        }
    },
    async mounted() {
        if(this.IsCordova) {
            window.SPEEDTEST_INIT = this.init;
        } else {
            await this.init();
        }

        //await this.init();
        
        this.checkAutoSpeedTest();
        this.AfterMountedForCordova();
    }
};